import React, { useCallback, useEffect, useReducer, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useAppDispatch } from "../../store";
import { useSelector } from "react-redux";
import { RootState } from "../../reducer/index";
import { useNavigate } from "react-router-dom";
import * as styles from "../../styles/WholedataPage";

import userSlice from "../../reducer/user";
import styled, { createGlobalStyle } from "styled-components/macro";
import Select from "react-select";
import { SelectOptionType } from "../../FrontType";
import postSlice from "../../reducer/post";
import { LoadDiaryList, LoadFarm } from "../../reduxaction/post";
import axios from "axios";
import { DiaryClasstype, TotaldataType } from "../../reducer/postpayloadtypes";
import { CSVLink, CSVDownload } from "react-csv";
import InsectName from "./PostDiary/component/InsectName";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import InsectLifeCycle from "./PostDiary/component/InsectLifeCycle";
import { check } from "yargs";

import { DataGrid, GridColDef, } from '@mui/x-data-grid'; // mui datagrid
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { DataGridStyle } from "../../styles/DataGridStyle";
import Modal from '@mui/material/Modal';


dayjs.locale("ko");
const Container = styled.div`
	display: flex;
	flex-direction: column;
	height: 100vh;
`;

const PageTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #dddddd;
  background-color: #fff;
  padding: 15px 0;
  font-size: 1.13em;
  position: relative;
  .pagetit {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 2.5vw;
    font-family: "spoqa500";
  }
  .move-btn {
    position: absolute;
    height: 100%;
    top: 0;
    right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    & img {
      cursor: pointer;
      width: 100%;
    }
  }

  @media screen and (min-width: 1050px) {
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #dddddd;
    background-color: #fff;
    padding: 20px 0;
    font-size: 1.4em;
    position: relative;

    .move-btn {
      position: absolute;
      width: 1.5%;
      height: 100%;
      top: 0;
      right: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      & img {
        cursor: pointer;
        width: 100%;
      }
    }
  }
`;

const DiarySelectBox = styled.div``;

const DiarySelectArrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 26px 20px 40px;
  background-color: #fff;

  p {
    font-size: 1.1em;
    font-weight: 700;

    &.diary-select-arrow-btn {
      cursor: pointer;
      transform: rotate(0deg);
      transition-duration: 1s;
    }

    &.diary-select-arrow-btn-rotate {
      transform: rotate(180deg);
      transition-duration: 1s;
    }
  }
`;

const DiarySelect = styled.div`
  transition-duration: 1s;
  &.show {
    overflow: hidden;
    max-height: 300px;
    transition-duration: 1s;
  }
  &.hide {
    overflow: hidden;
    max-height: 0px;
    transition-duration: 1s;
  }
`;

const DiarySelectOn = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0px 30px;
  transform: translateY(0px);
  transition-duration: 1s;
  background-color: #fff;

  .diary-select-item {
    width: 49%;
    margin-top: 5px;
    margin-bottom: 10px;
    & p {
      font-size: 1em;
      font-weight: 400;
      color: #656565;
      margin-bottom: 10px;
    }

    & select {
      width: 100%;
      height: 38px;
      margin-top: 5px;
      padding: 10px 8px;
      font-size: 0.88em;
    }

    & input {
      width: 48%;
      height: 38px;
      margin-top: 5px;
      padding: 10px 8px;
      font-size: 0.88em;
    }

    .diary-date-box {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      & p {
        width: 4%;
      }
    }
  }

  .diary-select-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px 0px;

    & div {
      margin-left: 0;
    }
    & .diary-select-Initialization {
      color: #656565;
      font-size: 1em;
      font-weight: 500;
      background-color: #fff;
      padding: 10px 26px 10px 27px;
      border-radius: 5px;

      & img {
        margin-right: 5px;
      }
    }

    & .diary-select-submit {
      padding: 10px 72px;
      background-color: #73972c;
      color: #fff;
      font-size: 1em;
      font-weight: 500;
      border-radius: 5px;
			&:hover {
				cursor: pointer;
			}
    }
  }
`;

const ExcelContainer = styled.div`
  width: 100%;
  background-color: #f7f7f7;
  padding: 10px 30px;
  min-height: 1000px;
  overflow: hidden;
  border-top: 1px solid #dddddd;
`;

const ExportCon = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const ExportBtn = styled.div`
  background-color: #537ff9;
  width: 80px;
  height: 40px;
  color: white;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 7px;
`;

const ExBody = styled.div`
  width: 100%;
  margin-top: 20px;
  border: 0.1px solid gray;
`;

const ExWapper = styled.div`
  display: flex;
  width: 100%;
`;

const RightCon = styled.div`
  width: 100%;
`;

const BasicCon = styled.div`
  display: flex;
  width: 100%;
`;

const Values = styled.div`
  padding: 10px 0px;
  width: 15%;
  font-size: 14px;
  background-color: #f7f7f7;
  text-align: center;
  border: 0.5px solid #dcd8d8;
  color: #2a3a4b;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BtnBox = styled.div`
  @media screen and (max-width: 1050px) {
    width: 80%;
    display: flex;
    align-content: center;
    justify-content: space-between;
    margin-top: 35px;
    & button {
      width: 48%;
      height: 38px;
      background: #73972c;
      color: white;
      border: none;
      border-radius: 5px;
      cursor: pointer;
    }
  }
`;

const SearchBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: '5px';
  border: '1px solid #ddd';
	input{
		padding: 8px 12px;
		border: 1px solid #ddd;
	}
	button{
		padding: 8px 12px;
		border: 1px solid #ddd;
		height: auto;
		font-size: revert;
	}
`;

const SearchInput = styled.input`
  margin-right: 10px;
  flex-grow: 1;
`;

const SearchButton = styled.button`
  width: 80px;
  height: 25px;
  border: 1px solid #000;
  cursor: pointer;
  background-color: #ffffff; /* White */
  color: black;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  transition-duration: 0.4s;
  &:hover {
    background-color: #f2f2f2;
    color: black;
  }
`;

export interface Headertype {
  label: string;
  key: string;
}

// type 선언
type ComprehensiveDataType = {
  results: {
    headerColumns: { key: string, header: string }[],
    data: any[],
  },
  total: number;
};

type BoxListType = {
  [key: string]: any;
};

const WholedataPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { me, Routerpath } = useSelector((state: RootState) => state.user);
  const { Farms, Diarylist, Targetfarms, DiarylistLoading, TargetfarmsDone, TargetInsectContainer } =
    useSelector((state: RootState) => state.post);

  let [arrow, setarrow] = useState(true);
  const [diarytype, setDiarytype] = useState<DiaryClasstype[]>([]);

  const [serchactive, setSerchactive] = useState<boolean>(false);

  const oneYearAgo = () => {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 1);
    return date.toISOString().split('T')[0];  // 'YYYY-MM-DD' 형식으로 반환
  };

  // 한달전
  const oneMonthAgo = () => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    return date.toISOString().split('T')[0];  // 'YYYY-MM-DD' 형식으로 반환
  }

  const today = () => {
    const date = new Date();
    date.setFullYear(date.getFullYear());
    return date.toISOString().split('T')[0];  // 'YYYY-MM-DD' 형식으로 반환
  };

  const [startdate, setStartdate] = useState<string>(oneMonthAgo);
  const [enddate, setEnddate] = useState<string>(today);

  const [totaldata, setTotaldata] = useState<any>();

  const [rsdata, setRsdata] = useState<TotaldataType[]>([]);
  const [rsheader, setRsheader] = useState<Headertype[]>([]);


  let [modal, setModal] = useState<number>(0);
  const [boxmodal, setBoxmodal] = useState<boolean>(false);

  let [placeId, setPlaceIds] = useState<any>([]); //placeId

  const [checkItems, setCheckItems] = useState<string[]>([]);

  let targetinsect: any;
  const [boxlist, setBoxlists] = useState<BoxListType>({});
  // let boxlist: any = [];

  let targetcontainer: any; // 현재 컨테이너 데이터

  // 검색어로 필터된 리스트
  const [filteredList, setFilteredList] = useState(boxlist);
  // 검색어 상태
  const [searchTerm, setSearchTerm] = useState('');
  const [orgboxlist, setOrgBoxList] = useState(boxlist);

  const [initialCheckItems, setInitialCheckItems] = useState<number[]>([]);

  const ITEMS_PER_PAGE = 10;
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };


  // 종합데이터 정보를 담는 state
  const [comprehensiveData, setComprehensiveData] = useState<ComprehensiveDataType | null>(null);

  // Pagination Model
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });

  // 데이터 그리드의 컬럼, 행 정의
  const [columns, setColumns] = useState<GridColDef[]>([]);
  const [rows, setRows] = useState<any[]>([]);
  const [backdropState, setBackdropState] = useState<boolean>(false);

  // console.log("****************************************************");
  // console.log(Targetfarms?.children);
  // console.log("****************************************************");

  // useEffect(() => {
  //   Targetfarms?.children.forEach((Obj, idx) => {

  //     console.log(Obj);
  //     Obj.children.forEach((item, idx) => {
  //       const newItem = {
  //         name: item.name,
  //         boxId: item.placeId,
  //         instar: item.children[0].instar,
  //       };

  //       setBoxlists((prevBoxlist) => [newItem, ...prevBoxlist]);
  //       setBoxList((prevBoxlist) => [newItem, ...prevBoxlist]);
  //     });
  //     console.log(boxlist);
  //   });
  // }, []);



  // console.log(boxlist);

  const data: any[] = [];

  const handleSingleCheck = (id: string) => {
    // checkItems에 id가 있는지 확인
    const currentIndex = checkItems.indexOf(id);
    const newChecked = [...checkItems];
    // 있으면 추가 없으면 제거
    if (currentIndex === -1) {
      newChecked.push(id);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setCheckItems(newChecked);
  };

  useEffect(() => {
    console.log("checkItems", checkItems);
  }, [checkItems]);

  const handleAllCheck = (e: any) => {
    if (e.target.id === "allCheck") {
      if (checkItems.length < Object.keys(boxlist).length) {
        setCheckItems(Object.keys(boxlist));
      } else {
        setCheckItems([]);
      }
    } else {
      setCheckItems([]);
    }
  };

  const findFilterObjectList = (searchTerm: string) => {
    // 검색된 searchTerm의 string이 boxlist의 key값에 포함되어 있는지 확인한다.
    // 포함되어 있다면 해당 key값을 가진 object를 boxlists에 담는다.
    const filtered = Object.entries(orgboxlist).filter(([key, value]) => key.includes(searchTerm));
    // 위와 같은 형태를 Object로 변환한다.
    const filteredObject = Object.fromEntries(filtered);
    return filteredObject;
  };

  const handleKeyPress = (event: any) => {
    if (event.key === 'Enter') {
      // Enter 키를 누르면 검색 이벤트를 실행합니다.
      setSearchTerm(event.target.value);

      if (searchTerm.trim() !== '') {
        const filteredObject = findFilterObjectList(searchTerm);
        setBoxlists(filteredObject);
      } else {
        setBoxlists(orgboxlist);
      }
    }
  };

  const handleClick = (event: any) => {
    setSearchTerm(event.target.value);

    if (searchTerm.trim() !== '') {
      const filteredObject = findFilterObjectList(searchTerm);
      setBoxlists(filteredObject);
    } else {
      setBoxlists(orgboxlist);
    }
  };

  // 검색어 입력 시 실행되는 함수
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const [selectedOption, setSelectedOption] = useState<any>({
    value: "",
    label: "",
  });

  const [diarytypes, setDiarytypes] = useState<any>({});

  // const modalClosefunc = useCallback(() => {
  // 	debugger;
  // 	console.log("checkItems11111", checkItems);
  // 	setCheckItems([...checkItems]);
  // 	setBoxmodal((prev) => !prev);
  // }, [checkItems]);

  // const modalkeepfunc = useCallback(() => {
  // 	setBoxmodal((prev) => !prev);
  // }, []);

  const handleClose = () => {
    setBoxmodal(false);
  };


  const handleboxBtn = (
    boxname: any,
    boxId: any,
    idx: any,
    productCode: any
  ) => {

    // setInsectkind(productCode);
    // setPlaceIds([...placeId, boxId]);

    // let alreayid = placeId.includes(boxId);

    // if (alreayid) {
    //   let filterdata = placeId.filter((v: any) => v !== boxId);

    //   setPlaceIds([...filterdata]);
    // }

  };

  useEffect(() => {
    dispatch(LoadFarm());
  }, [dispatch]);

  useEffect(() => {
    dispatch(userSlice.actions.Routerpath("/WholedataPage"));
  }, []);

  // 곤충 API
  const settingInsect = async () => {
    return await axios
      .get(`/ifactory/api/productcode`)
      .then((res) => res.data)
      .catch((error) => {
        console.log("곤충 리스트 가져오기 실패", error);
      });
  };

  const [insects, setInsects] = useState<any[]>([]);
  const [result, setResult] = useState<any[]>([]);
  useEffect(() => {
    settingInsect().then((res) => {
      setInsects(res);

      // 중복을 제거
      const getUniqueElements: SelectOptionType[] = res.filter((v: any, i: number) => {
        return res.findIndex((x: any) => x.productCode === v.productCode) === i;
      });
      // insects에 lavel, value 형태로 저장
      setResult(getUniqueElements.map((v: any) => ({ label: v.productName, value: v.productCode })));
    });
  }, []);


  // const insects = Targetfarms
  //   ? Targetfarms.children.map((place) => {
  //       return {
  //         label: InsectName(place?.productCode),
  //         value: place?.productCode,
  //       };
  //     })
  //   : [];

  // 중복 제거
  // const result: SelectOptionType[] = insects.filter(
  //   (v: any, i: number) => insects.findIndex((x) => x.label === v.label) === i
  // );

  const onChangtimefunc = (e: any) => {
    if (e.target.name === "start") {
      setStartdate(e.target.value);
    } else if (e.target.name === "end") {
      setEnddate(e.target.value);
    }
  };

  // useEffect(() => {
  //   const searchBox = async () => {
  //     try {
  //       const response = await axios.get(`/ifactory/api/managebox?farmId=${localStorage.getItem("targetfarm")}`);
  //       setBoxlists(response.data);
  //       setOrgBoxList(response.data);

  //       console.log(response);
  //     } catch (error) {
  //       // 오류 처리
  //     }
  //   };

  //   // 페이지 로딩 시에 실행
  //   searchBox();
  // }, []);

  const searchBox = useCallback(async () => {
    try {
      const response = await axios.get(
        `ifactory/api/diary/comprehensiveBox?farmId=${localStorage.getItem("targetfarm")}&productCode=${selectedOption.value}&diaryType=${diarytypes.value}&startDate=${startdate}&endDate=${enddate}`
      );
      console.log("response : ", response)
      setBoxlists(response.data);
      setOrgBoxList(response.data);
    } catch (error) {
      // 오류 처리
    }
  }, [selectedOption, diarytypes, startdate, enddate]);

  useEffect(() => {
    if (boxmodal === true) {
      searchBox();
    }
  }, [boxmodal]);


  const handleSearch = () => {
    searchfunc().then(() => {
      setBoxmodal(false);
    });
  };

  const searchfunc = useCallback(async () => {
    try {
      let numList: any = [];
      const orgboxlistKeys = Object.keys(orgboxlist);
      const isAllChecked = checkItems.length === orgboxlistKeys.length && checkItems.every((v) => orgboxlistKeys.includes(v));

      if (!isAllChecked) {
        const setNumList = checkItems.map((v) => {
          return orgboxlist[v];
        });
        numList = setNumList;
      };

      const response = await axios({
        method: 'get',
        url: 'ifactory/api/diary/comprehensive',
        params: {
          farmId: localStorage.getItem("targetfarm"),
          manageBoxIds: numList.join(','),
          productCode: selectedOption.value,
          diaryType: diarytypes.value,
          startDate: startdate,
          endDate: enddate,
          page: paginationModel.page,
          size: paginationModel.pageSize,
        }
      });
      console.log(response);

      if (response.data.results.data.length < 1) {
        confirmAlert({
          title: "선택하신 날짜에 데이터가 없습니다.",
          buttons: [
            {
              label: "Yes",
              onClick: () => {
                setBoxmodal(false);
                setSerchactive(false);
                return;
              }
            },
          ],
        });
      }

      setTotaldata(response.data.results);
      setComprehensiveData(response.data);

    } catch (error) { }

    setSerchactive(true);
  }, [
    Targetfarms,
    selectedOption,
    diarytypes,
    startdate,
    enddate,
    serchactive,
    checkItems,
    totaldata,
  ]);



  useEffect(() => {
    const hello = async () => {
      if (Targetfarms) {
        const diyartype = await axios.get(`/ifactory/api/diarycode/class`);

        const diarytypes = diyartype.data.map((diary: DiaryClasstype) => {
          return { label: diary.name, value: diary.diaryType };
        });

        const results: any = diarytypes.filter(
          (v: any, i: number) =>
            diarytypes.findIndex((x: any) => x.label === v.label) === i
        );

        // const updateDiarytypes = [...results, { label: "전체", value: "WHOLE" }];
        const updateDiarytypes = [...results];

        // results.push({ label: "전체", value: "WHOLE" });
        setDiarytype(updateDiarytypes);
        setDiarytypes(updateDiarytypes[0]);
      }
    };

    hello();
  }, [Targetfarms, me]);

  let headers: Headertype[] = [];
  if (diarytypes.value === "GROWTH") {
    headers.push(
      { label: "상자이름", key: "boxName" },
      { label: "곤충명", key: "InsectName" },
      { label: "작업일", key: "TagStdDate" },
      { label: "생육상태", key: "Instar" },
      { label: "작업상태", key: "DiaryType" },
      { label: "사육시작일", key: "StartFarmDate" },
      { label: "출하예정일", key: "ExpFarmDate" },
      { label: "출하일", key: "endFarmDate" },
      { label: "메모", key: "note" },
      { label: "개체무게", key: "wormWeight" },
      { label: "곤충길이", key: "wormLength" },
      { label: "곤충두폭", key: "wormHeadSize" }
    );
  } else if (diarytypes.value === "REPLACEFEED") {
    headers.push(
      { label: "상자이름", key: "boxName" },
      { label: "곤충명", key: "InsectName" },
      { label: "작업일", key: "TagStdDate" },
      { label: "생육상태", key: "Instar" },
      { label: "작업상태", key: "DiaryType" },
      { label: "사육시작일", key: "StartFarmDate" },
      { label: "출하예정일", key: "ExpFarmDate" },
      { label: "출하일", key: "endFarmDate" },
      { label: "메모", key: "note" },
      { label: "개체군무게", key: "wormTotalWeight" },
      { label: "분변토량", key: "soilWeight" },

      { label: "누적급이량", key: "totalFeedWeight" },

      { label: "누적분변토량", key: "totalSoilWeight" }
    );
  } else if (diarytypes.value === "CLEAN") {
    headers.push(
      { label: "상자이름", key: "boxName" },
      { label: "곤충명", key: "InsectName" },
      { label: "작업일", key: "TagStdDate" },
      { label: "생육상태", key: "Instar" },
      { label: "작업상태", key: "DiaryType" },
      { label: "사육시작일", key: "StartFarmDate" },
      { label: "출하예정일", key: "ExpFarmDate" },
      { label: "출하일", key: "endFarmDate" },
      { label: "메모", key: "note" },
      { label: "청소/소독", key: "cleanDate" }
    );
  } else if (diarytypes.value === "FEED") {
    headers.push(
      { label: "상자이름", key: "boxName" },
      { label: "곤충명", key: "InsectName" },
      { label: "작업일", key: "TagStdDate" },
      { label: "생육상태", key: "Instar" },
      { label: "작업상태", key: "DiaryType" },
      { label: "사육시작일", key: "StartFarmDate" },
      { label: "출하예정일", key: "ExpFarmDate" },
      { label: "출하일", key: "endFarmDate" },
      { label: "메모", key: "note" },
      { label: "사료이름", key: "feedName" },
      { label: "급이량", key: "feedWeight" },
      { label: "상자내 사료무게", key: "boxFeedWeight" },
      // { label: "첫밥/마지막밥", key: "feedTime" },
      { label: "첫밥", key: "feedTime" },
      { label: "마지막밥", key: "lastfeedTime" },

      { label: "사육상자무게", key: "boxWeight" },
      { label: "개체예상마리수", key: "expAmount" },
      { label: "급이누적횟수", key: "feedTotalCount" }
    );
  } else if (diarytypes.value === "DISEASE") {
    headers.push(
      { label: "상자이름", key: "boxName" },
      { label: "곤충명", key: "InsectName" },
      { label: "작업일", key: "TagStdDate" },
      { label: "생육상태", key: "Instar" },
      { label: "작업상태", key: "DiaryType" },
      { label: "사육시작일", key: "StartFarmDate" },
      { label: "출하예정일", key: "ExpFarmDate" },
      { label: "출하일", key: "endFarmDate" },
      { label: "메모", key: "note" },
      { label: "발현두수", key: "DiseaseCount" },
      { label: "곤충폐사무게", key: "wormDeadWeight" }
    );
  } else if (diarytypes.value === "WHOLE") {
    headers.push(
      { label: "상자이름", key: "boxName" },
      { label: "곤충명", key: "InsectName" },
      { label: "작업일", key: "TagStdDate" },
      { label: "생육상태", key: "Instar" },
      { label: "작업상태", key: "DiaryType" },
      { label: "사육시작일", key: "StartFarmDate" },
      { label: "출하예정일", key: "ExpFarmDate" },
      { label: "출하일", key: "endFarmDate" },
      { label: "메모", key: "note" },

      // 생육조사
      { label: "개체무게", key: "wormWeight" },
      { label: "곤충길이", key: "wormLength" },
      { label: "곤충두폭", key: "wormHeadSize" },
      // 사료교체
      { label: "개체군무게", key: "wormTotalWeight" },
      { label: "분변토량", key: "soilWeight" },

      { label: "누적급이량", key: "totalFeedWeight" },

      { label: "누적분변토량", key: "totalSoilWeight" },

      // 청소소독
      { label: "청소/소독", key: "cleanDate" },

      // 급이
      { label: "사료이름", key: "feedName" },
      { label: "급이량", key: "feedWeight" },
      { label: "상자내 사료무게", key: "boxFeedWeight" },
      // { label: "첫밥/마지막밥", key: "feedTime" },
      { label: "첫밥", key: "feedTime" },
      { label: "마지막밥", key: "lastfeedTime" },
      { label: "사육상자무게", key: "boxWeight" },

      { label: "개체예상마리수", key: "expAmount" },
      { label: "급이누적횟수", key: "feedTotalCount" },
      // 질병
      { label: "발현두수", key: "DiseaseCount" },
      { label: "곤충폐사무게", key: "wormDeadWeight" }
    );
  }



  const handleDownload = () => {
    // 파일 다운로드
    const fileName = `종합데이터_${dayjs().format("YYYYMMDD_HHmmss")}`;

    const getFile = async () => {
      try {
        let numList: any = [];
        const orgboxlistKeys = Object.keys(orgboxlist);
        const isAllChecked = checkItems.length === orgboxlistKeys.length && checkItems.every((v) => orgboxlistKeys.includes(v));

        if (!isAllChecked) {
          const setNumList = checkItems.map((v) => {
            return orgboxlist[v];
          });
          numList = setNumList;
        };


        const response = await axios.get(`ifactory/api/diary/comprehensive/excel`, {
          params: {
            farmId: localStorage.getItem("targetfarm"),
            manageBoxIds: numList.join(','),
            productCode: selectedOption.value,
            diaryType: diarytypes.value,
            startDate: startdate,
            endDate: enddate,
          },
          responseType: "blob",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${fileName}.xlsx`);
        document.body.appendChild(link);
        link.click();
      } catch (error: any) {
        console.error(error);
      }

      setBackdropState(false);
    };

    setBackdropState(true);
    getFile();
  };


  //! useEffect
  // 데이터 그리드의 컬럼 정의
  useEffect(() => {
    const createColumns = () => {
      const headerColumns = comprehensiveData?.results.headerColumns || [];
      return headerColumns.map(column => ({
        field: column.key,
        headerName: column.header,
        sortable: true,
        width: 200,
        headerAlign: 'center' as 'center',
        align: 'center' as 'center',
      }));
    };

    const columns = createColumns();
    setColumns(columns);
  }, [comprehensiveData]);

  useEffect(() => {
    const rows = comprehensiveData?.results.data.map((row, index) => {
      const newRow = { id: index + 1, ...row };

      for (const key in newRow) {
        if (key.includes('Date') && dayjs(newRow[key]).isValid()) {
          newRow[key] = dayjs(newRow[key]).format('YYYY-MM-DD A HH:mm');
        }
      }

      return newRow;
    });
    setRows(rows || []);
  }, [comprehensiveData, columns]);

  // 페이지 변경 처리
  useEffect(() => {
    if (!comprehensiveData) return;
    const handlePagination = async () => {
      await searchfunc();
    };
    handlePagination();
  }, [paginationModel]);

  const checkedAllCheckItems = () => {
    // checklist에 boxlist의 모든 key값이 있느지 확인
    const checked = Object.keys(boxlist).every((key) => checkItems.includes(key));
    return checked;
  }

  const handleInsectChange = (e: any) => {
    setSelectedOption(e);
  }

  const handleBoxModal = (e: any) => {
    if (!!selectedOption.value) {
      setBoxmodal(true);
    } else {
      confirmAlert({
        title: "곤충을 선택해주세요.",
        buttons: [
          {
            label: "Yes",
            onClick: () => {
              return;
            },
          },
        ],
      });
    }
  };


  return (
    <Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropState}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <PageTop>
        <p className="pagetit">종합데이터</p>
        <p className="move-btn">
          <img
            src="./img/X.svg"
            onClick={() => {
              navigate(-1);
            }}
            alt="X"
          />
        </p>
      </PageTop>

      <DiarySelectBox>
        <DiarySelectArrow>
          <p>상세검색</p>
          <p
            className={
              arrow === true
                ? "diary-select-arrow-btn"
                : "diary-select-arrow-btn-rotate"
            }
            onClick={() => {
              setarrow(!arrow);
            }}
          >
            ▲
          </p>
        </DiarySelectArrow>
        <DiarySelect className={arrow === true ? "show" : "hide"}>
          <DiarySelectOn>
            <div className="diary-select-item">
              <p>곤충명</p>
              <Select
                className="select"
                defaultValue={null}
                onChange={handleInsectChange}
                options={result}
                menuPortalTarget={document.body}
                styles={{
                  control: (baseStyles: any, state) => ({
                    ...baseStyles,
                    borderColor: state.isFocused
                      ? "rgb(118, 118, 118)"
                      : "#DDDDDD",
                    width: "100%",
                    backgroundColor: "#F7F7F7",

                    ":active": {
                      borderColor: state.isFocused ? "black" : "black",
                    },
                  }),
                }}
              />
            </div>

            <div className="diary-select-item">
              <p>작업선택</p>

              <Select
                value={diarytypes}
                onChange={setDiarytypes}
                options={diarytype}
                menuPortalTarget={document.body}
                styles={{
                  control: (baseStyles: any, state) => ({
                    ...baseStyles,
                    borderColor: state.isFocused
                      ? "rgb(118, 118, 118)"
                      : "#DDDDDD",
                    width: "100%",
                    backgroundColor: "#F7F7F7",
                  }),
                }}
              />
            </div>
            <div className="diary-select-item ">
              <p>기간선택</p>
              <div className="diary-date-box">
                <input
                  style={{
                    backgroundColor: "#F7F7F7",
                    border: "1px solid #DDDDDD",
                  }}
                  type="date"
                  name="start"
                  id="start"
                  value={startdate}
                  onChange={(e) => onChangtimefunc(e)}
                />
                <p
                  style={{
                    width: "30px",
                    textAlign: "center",

                    fontSize: 20,
                    fontWeight: "bold",
                    top: 5,
                    position: "relative",
                  }}
                >
                  ~
                </p>
                <input
                  style={{
                    backgroundColor: "#F7F7F7",
                    border: "1px solid #DDDDDD",
                  }}
                  type="date"
                  name="end"
                  id="end"
                  value={enddate}
                  onChange={(e) => onChangtimefunc(e)}
                />
              </div>
            </div>

            <div className="diary-select-btn">
              <div className="diary-select-submit" onClick={handleBoxModal}>
                상자선택
              </div>
            </div>
          </DiarySelectOn>
        </DiarySelect>
      </DiarySelectBox>

      <div style={{ borderBottom: "1px solid #dddddd" }} />
      {/* 종합데이터 DATA GRID */}
      <DataGridStyle>
        <style>
          {`
          .MuiDataGrid-cell, .MuiDataGrid-columnHeader{
            box-shadow: 0.5px 0 0.5px 0 #dddddd;
          }
        `}
        </style>
        <div className="DataGridWrap">
          {columns && columns.length > 0 && rows && rows.length > 0 && comprehensiveData ? (
            <div>
              {/* 파일 다운로드를 위한 버튼 생성 */}
              <button className="download_btn" onClick={handleDownload}>내보내기</button>
              <DataGrid
                columns={columns}
                rows={rows}

                initialState={{
                  pagination: {
                    paginationModel: { pageSize: 50, page: 0 },
                  },
                }}

                paginationMode="server"
                onPaginationModelChange={setPaginationModel}
                rowCount={comprehensiveData.total}
                pageSizeOptions={[50]}
                disableColumnMenu
              />
            </div>

          ) : (
            <div className="noData">
              <p>조회된 데이터가 없습니다.</p>
            </div>
          )}
        </div>
      </DataGridStyle>

      {boxmodal ? (
        <Modal open={boxmodal} onClose={handleClose}>
          <styles.SModalContainer>
            <styles.SModals>

              <SearchBox>
                <SearchInput type="text" placeholder="상자 이름 검색"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  onKeyPress={handleKeyPress}
                />
                <SearchButton onClick={handleClick}>검색</SearchButton>
              </SearchBox>


              <styles.BreedingBoxBot>
                {boxlist && Object.keys(boxlist).length !== 0 ? (
                  <div style={{ width: "100%", overflowY: "auto", height: "500px", borderBottom: "1px solid #dddddd", paddingBottom: "20px" }}>

                    <ul className="breeding-box-list">
                      <li>
                        <button type="button"
                          id="allCheck"
                          className={checkedAllCheckItems() ? "checked" : ""}
                          onClick={(e) => handleAllCheck(e)}>전체</button>
                      </li>
                      {Object.keys(boxlist).map((box: any, idx: any) => {
                        return (
                          // <li key={idx}>{box}</li>
                          <li key={idx}>
                            <button type="button"
                              id={`boxCheck-${idx}`}
                              className={checkItems.includes(box) ? "checked" : ""}
                              onClick={(e) => handleSingleCheck(box)}
                            >
                              {box}
                            </button>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                ) : (<div style={{ color: "#666" }}>선택한 조건에 맞는 상자가 없습니다.</div>)}
              </styles.BreedingBoxBot>
            </styles.SModals>
            <div className="modal-btn-area">
              {
                Object.keys(boxlist).length > 0 ? (<button className="modal-btn" onClick={handleSearch}>검색</button>) : null
              }

              <button className="modal-btn" onClick={handleClose}>닫기</button>
            </div>
          </styles.SModalContainer>
        </Modal>
      ) : null}

    </Container>


  );
};

export default WholedataPage;
